module.exports = __webpack_public_path__ + "static/media/ic_report.217df8bb.svg";